import Vue, { CreateElement } from 'vue';
// import { BootstrapVue } from 'bootstrap-vue';
import VueCookies from 'vue-cookies';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import axios from 'axios';
import VueToastr from 'vue-toastr';
import VCalendar from 'v-calendar';
import VueProgressBar from 'vue-progressbar';
import '@/assets/scss/main.scss';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { AdmiralApi } from '@/services/AdmiralApi';
import TaskOverview from '@/views/pages/tasks/TaskOverview.vue';
import BootstrapVue from 'bootstrap-vue';
import VueShepherd from 'vue-shepherd';
import Shepherd from 'shepherd.js';
import { componentPath, PROGRESS_BAR_CONFIG, TOASTR_CONFIG } from '@/utils/helpers';

declare module 'vue/types/vue' {
  interface Vue {
    $Progress: any; // eslint-disable-line
    $toastr: any; // eslint-disable-line
    $shepherd: (...args: any[]) => Shepherd.Tour; // eslint-disable-line
  }
}
declare global {
  interface Window {
    plausible: any;
    op: any;
  }
}
declare global {
  interface Window {
    app: Vue;
  }
}

// Install BootstrapVue
// Vue.use(TooltipPlugin);
// Vue.use(NavbarPlugin);
// Vue.use(ButtonPlugin);
// Vue.use(VBModalPlugin);
// Vue.use(ModalPlugin);
//
// Vue.use(ProgressPlugin);
// Vue.use(TabsPlugin);
// Vue.use(CardPlugin);

Vue.use(VueShepherd);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(VCalendar, {});
Vue.use(VueToastr, TOASTR_CONFIG);
Vue.use(VueProgressBar, PROGRESS_BAR_CONFIG);
Vue.component('task-overview', TaskOverview);
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus();
  },
});

Vue.config.errorHandler = async (err: Error, vm, info) => {
  console.error(err);
  if (process.env.VUE_APP_NODE_ENV === 'production') {
    await AdmiralApi.logError({
      info: info,
      vm: componentPath(vm),
      message: err.message,
      stack: err.stack?.toString(),
      data: JSON.stringify((err as any).response?.data), // eslint-disable-line
    });
  }
};
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
window.app = new Vue({
  store,
  router,
  render: (h: CreateElement) => h(App),
}).$mount('#app');
